
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import {
    Client,
    IJobItemModel,
    JobItemScheduleModel,
    IJobItemScheduleModel,
    JobItemType,
    JobItemUpdateScheduleModel
  } from '@/services/api.service';
  import { EventBus } from '@/event-bus';
  import { JobItemRescheduledMessage } from '@/services/eventbus.models';
  import toISODateFormatter from '@/filters/toISOdate.formatter';
  import DatePicker from '@/components/commonui/DatePicker.vue';

  import * as StringUtils from '@/utilities/string.utils';
  import * as DateUtils from '@/utilities/date.utils';

  @Component({
    components: {
      DatePicker
    },
    props: {
      jobItemSchedule: {
        type: Object as () => IJobItemScheduleModel,
        required: true
      },
      jobItemGid: String,
      jobGid: String,
      isInDialogMode: Boolean
    },
    filters: {
      toISODate: toISODateFormatter
    }
  })
  export default class RescheduleJobItem extends Vue {
    private originalScheduledDate?: Date;
    private scheduledTimeRange: string = '';
    private scheduledDate: Date = new Date();

    private mounted() {
      console.log('Rescheduling job item: Source:');
      console.log(this.$props.jobItemSchedule);
      this.originalScheduledDate = this.$props.jobItemSchedule.scheduledDate;
      this.scheduledDate = this.$props.jobItemSchedule.scheduledDate;
      this.scheduledTimeRange = this.$props.jobItemSchedule.scheduledTimeRange;
    }

    private updateSchedule() {
      const me = this;
      const item = this.$props.jobItemSchedule;

      console.log('Rescheduling job item:');

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      const updateModel: JobItemUpdateScheduleModel = new JobItemUpdateScheduleModel();
      updateModel.jobItemGid = this.$props.jobItemGid;
      updateModel.jobItemScheduleGid = this.$props.jobItemSchedule.gid;

      updateModel.scheduledDateISO = DateUtils.toIsoDate(this.scheduledDate);
      updateModel.scheduledTimeRange = this.scheduledTimeRange;

      updateModel.assignedToEmployeeGid = item.assignedToEmployeeGid || undefined;
      updateModel.estimatedTravelTimeInMinutes = item.estimatedTravelTimeInMinutes;
      updateModel.estimatedDurationInMinutes = item.estimatedDurationInMinutes;

      console.log(updateModel);
      clientService
        .scheduleJobItem(this.$props.jobGid, this.$props.jobItemGid, updateModel)
        .then(data => {
          // update the current item with the new values
          item.jobItemScheduleGid = data.gid!;
          item.scheduledTimeRange = data.scheduledTimeRange!;

          // @ts-ignore
          this.$Progress.finish();

          // Push out some events to refresh things
          this.$emit('job-item-rescheduled', data);
          EventBus.$emit('job-item-rescheduled', new JobItemRescheduledMessage(data));
          this.closeModal();
          // @ts-ignore
          this.$awn.success('Job task successfully rescheduled.');
        })
        .catch(reason => {
          // @ts-ignore
          this.$Progress.fail();
          // @ts-ignore
          this.$awn.alert('Failed to reschedule the job item. \r\n' + reason.message);
        });
    }

    private cancelEdit() {
      console.log('Cancelling edit...');
      this.closeModal();
    }

    private closeModal() {
      if (this.$props.isInDialogMode) {
        this.$modal.hide('modal-jobitem-reschedule');
      }
    }
  }
